export default {
  "+wet4N": "認証コードエラー",
  "2QzYmY": "キャンセル",
  "32AbcK": "会社を選択",
  "4R5GEq": "ホーム",
  "9Kfib+": "不明なエラー",
  "9UZxwP": "確認コードを入力してください",
  "9cYMNA": "会社情報",
  "9ljNkr": "再送信",
  "9vpYSL": "会社を削除",
  "EWMpn/": "ロールを削除",
  FEb7U2: "確認",
  "J3BW/8": "メールで受け取った確認コードを入力してください",
  "QK/hAI": "表示権限",
  TqDOFU: "確認コードを頻繁に送信しないでください!",
  XeiAal: "削除",
  aiBGBs: "正常に削除されました",
  azDNha: "正常に送信されました",
  "e/6XZC": "確認コードを受信しませんでしたか?",
  jNxbTC: "検証コードを空にすることはできません",
  l1fZNE: "すべてのボックスのチェックを外すことはできません",
  "2MYr1m": "ログイン",
  "lzP/we": "ダウンロード",
  m0Qdyj: "検証に失敗しました",
  nJCPaY:
    "ユーザーには電子メール アドレスがバインドされていないため、検証できません",
  x79O39: "削除してもよろしいですか?",
  xxETOY: "企業データ権限設定",
  yGWx2z: "パラメータエラー",
  Unvxiq: "アカウントを切り替える",
  ggvI6Z: "すべて選択",
  lKbhpS: "デバイスのグレースケール更新可能期間(現地時間)",
  ayUfs1: "終了時刻を開始時刻より早くすることはできません",
  "03eM6t": "200 アイテム/ページ",
  "7/cUwn": "デバイス更新可能期間 (現地時間)",
  SGDlQ6: "合計 {total} 個のアイテム",
  "arp+TQ": "50 アイテム/ページ",
  e8OyHO: "20 アイテム/ページ",
  iyOrrD: "100 アイテム/ページ",
  yXsHgv: "10 項目/ページ",
  "+/R6RX": "タスクのステータス",
  "+0SHNk": "Wi-Fi MAC アドレス",
  "+4lD9e": "名前",
  "+74JfZ": "例: Device_000001_Gaoqiao Store_Android",
  "+7V2pl": "一般",
  "+CLSks": "2. この命名規則が適用されるデバイス システム タイプ",
  "+GQdfc": "トークンの更新",
  "+L9lak": "アラームテンプレートを適用する",
  "+TzicH": "店",
  "+gbx50": "警報状態",
  "+kHAfa": "店舗詳細をご記入ください",
  "+m8vFq": "命名規則の詳細",
  "/8GfsH": "4",
  "/99v4N": "全店舗",
  "/CxA3j": "サブストアの追加",
  "/Qlgz9": "Windows デバイスをアップロードする",
  "/SqqyP": "デバイスのシリアル番号を入力してください",
  "/cqdKk": "ダウンロード",
  "/sI6h+": "人々",
  "0KH9Qi": "デバイスのシステムタイプ",
  "0VK6Tv": "営業状況",
  "0YYUNG": "{num} 個のタグが選択されました",
  "0iTEVO": "トークンの表示",
  "0uRy1k": "1つ",
  "11uVJ/": "受信オブジェクト",
  "19+woq": "店舗詳細",
  "1M03Dq": "スケジュールテンプレート",
  "1PtjRr": "デバイス名",
  "1SslIM": "アプリを閉じる",
  "1X8SYs": "緯度と経度",
  "1sAivX": "イーサネットMACアドレス",
  "1sj5Sj":
    "このデバイスに適用されているすべてのスケジュール テンプレートを削除します",
  "2/LdaO": "構成情報を保存する",
  "2JW1Pt": "同時にメールを送信するかどうかを選択してください",
  "2nV3tA": "ストアが選択されていません",
  "2opnVU": "実行中",
  "2qrsN7": "店舗の住所を選択してください",
  "2r/XUW":
    "このタグによって適用されたすべてのスケジュール テンプレートを削除します",
  "3HzQUc": "JSONのエクスポート",
  "3QXG/d": "オラ版",
  "3XHWMy": "木曜日",
  "3aYG4L":
    "現在デバイスに適用されているアラーム テンプレートを削除し、アラームの監視と送信を行わなくなります。",
  "3h+3Xm": "営業していません",
  "3jyOjJ": "選択したデバイスを「登録済み」に変更するかどうか",
  "3qF993": "現在の会社に属していないデバイスを譲渡することはできません。",
  "4/e9qs": "名前を入力してください",
  "4Xdib8": "期間を空にすることはできません",
  "4c3uw8": "店外へ移動する",
  "4vWL+W": "デバイスのインポート",
  "4wi+/p": "テンプレート",
  "5+oaTO": "画像の最終更新ステータス",
  "5Cm9U3": "メッセージ通知",
  "5Hy0Qx": "同一店舗への譲渡はできません",
  "5KtG4i": "検索事業",
  "5WKL9+": "ストアステータスを選択してください",
  "5jpkHg": "オンラインステータス",
  "5p8cBO": "アカウント管理",
  "5ytYaf": "新しいスケジュール テンプレートを追加する",
  "6+iYA0": "シリアルナンバー",
  "60Ixlm": "アラームテンプレート名",
  "6eB+xj": "特定のユーザーを選択してください",
  "6pDRb2": "有効なパスワードを入力してください",
  "7ip592": "1. ネーミングルール名",
  "88CuCZ":
    "3.当ストアに登録されている機器の命名方法を確立（機器名を自動記入）",
  "8PESa6": "無効にする",
  "8huAxo": "新しいルールを追加",
  "8u3CYe": "命名規則名",
  "8usMqO": "お知らせの削除",
  "8zN+hZ": "アプリケーションの実行",
  "9/Vb7e": "デバイスをアップロードする",
  "919TK9": "サポートされている形式: xls、xlsx",
  "9AsSO/": "同時にテキストメッセージを送信するかどうかを選択してください",
  "9UefLp": "ラベル",
  "9g6s9o": "店舗コードを入力してください",
  "9iKk2b": "開始番号",
  "9r00YD": "お知らせ管理",
  "9w+ho+": "アカウント",
  "9yRpjk": "土曜日",
  "A/eXwT":
    "このラベルに適用されているすべてのアラーム テンプレートを削除します",
  A5kf1W: "全社一覧",
  ANeFu6: "パスワードを確認してください",
  Abqe2U: "店舗住所",
  Axagls: "終了時間を選択してください",
  AyWMlZ: "スケジュールされたタスクを追加する",
  B57Wbu: "デバイスが選択されていません",
  BBpRbn: "このストアに適用されているすべてのアラーム テンプレートを削除します",
  BC74I9: "プロンプトメッセージ",
  BQcLxf: "下に移動",
  BYbqwY: "ファイルをここにドラッグするか、「アップロード」をクリックします",
  BwXapw: "カテゴリ名は500文字以内でお願いします",
  C6cGK1: "スケジュールテンプレート名を空にすることはできません",
  CLqPBU: "編集",
  CPTAAj: "自然数の増加",
  D5HOUz: "ステータスの選択",
  DADacD:
    "このストアに適用されているすべてのスケジュール テンプレートを削除します",
  DFyP1k: "店を閉じる",
  DxGUhN: "すべてのデバイスを選択します",
  E1GPl7: "所有者",
  EGvInA: "デバイスアラームリスト",
  EM8lAi: "自社設備による更新可能期間（現地時間）",
  "EO+Nlk":
    "ファイルをアップロード中です。ダイアログ ボックスを閉じないでください。",
  EwM8Kj: "本当に退去してもよろしいですか?",
  Ey9rBq: "削除してもよろしいですか?",
  F2LJDJ: "削除してもよろしいですか?",
  F3ndvv: "削除に失敗しました",
  FBH89G: "修正版",
  FNIJXx: "スクロール再生を選択してください",
  "FaJ/jI": "インポートするファイルが選択されていません",
  FbCeo1: "トリガー値",
  FbsCUK: "携帯電話",
  "Fr1I/b": "ラベル",
  Ft60hS: "ヌビス装備",
  G4XFn6: "ハードウェアモデル",
  G4qgGm: "すべてのユーザー",
  G5gg2V: "お知らせのタイトルは必須です",
  G6i1QR: "住所を選択してください",
  G9APSK: "命名規則を編集する",
  Gk0Mt5:
    "警報装置 ({name}) をリセットしてもよろしいですか?アラーム ルールはリセット後も監視を続けます。",
  GnzEo7: "画像の最終更新時間",
  GujK99:
    "後でアラーム テンプレートの内容が更新された場合、適用されたデバイスにも同期されます。",
  Gwj7xc: "デフォルトに戻す",
  H5s58g: "24時間",
  HN1dNJ: "すべてのアカウント",
  HOHQFs: "命名規則名を空にすることはできません",
  HRXYJB: "全社",
  "HdxQ2/": "ストア関連の構成ファイルと命名規則",
  "Hv/pfB": "火曜日",
  I37xbU: "ご記入ください",
  ITbo35: "ストア名を空白にすることはできません。",
  IqkgWZ: "キーワード",
  "Iwt/8W": "注釈",
  "J0D5h+": "開始時間",
  J9jPRL: "正常にコピーされました",
  JJl2M9: "輸出",
  JLMIof: "Android デバイスをアップロードする",
  JRhVym: "営業時間を空けることはできません",
  JeJAmT: "名前の変更",
  Jh62y5: "すべてのデバイス",
  Jp7u8z: "タワー",
  KJHvMA: "店舗運営",
  KlWMzW: "アクティブ化された",
  Km733q: "開始時間を選択してください",
  Kwqd8h: "連絡担当者",
  L24ioQ: "タイトル",
  L80hmc: "お知らせのタイトルは 30 文字を超えてはなりません",
  LNGTru: "デバイススケジューリング失敗リスト",
  LWSLHa: "親切なヒント",
  Lfia0v: "スケジュールを設定する",
  "LuP+H0": "説明する",
  LwhdsE: "複数選択の切り替え",
  M404r0: "二",
  MZ5Ei7: "期間は {num} 番目の期間と重複しています",
  MmsEyp: "登録する",
  MnTdIi: "トリガーの数",
  N52KMq: "詳しい住所",
  NGs9sO: "戻る",
  "NM/lRq": "アップロードをキャンセルする",
  NjB2tN: "営業状況を選択してください！",
  OMcnk6: "メーカー",
  OSqnZu: "選択したデバイスのバージョンを次のように変更するかどうか",
  "OZGX3+": "お知らせ一覧",
  OaZpDP: "UUID",
  OcijhH: "マザーボードのシリアル番号",
  OsMncl: "電源が入っていない",
  "P/eul9": "いいえ",
  PVmkgT: "短い名前を入力してください",
  PaMvre: "アラームルール一覧",
  PnYplH: "装置",
  PrIueu: "２４時間営業",
  "Py/5UG": "操作中のノードは存在しませんので、再度操作してください。",
  "Q+0CDu": "命名規則を追加する",
  "Q2/NzC": "{num} 台のデバイスが選択されました",
  QHc9Qg: "発表内容",
  QHhMxE: "役割の選択",
  QLYuf8: "全社",
  QV3pnn: "州",
  QpOtgZ: "店名",
  Qpcx6F: "お知らせ内容は必須です",
  Qpi3DY: "日",
  "QsAe0/": "保存に失敗しました",
  QwHI8Q: "クエリ結果:",
  R2D5Dv: "作成時間",
  RCjVsb: "デバイスID",
  RNaGVr: "タスク失敗リスト",
  RQyKsa: "プラットフォームの発表",
  RWBRyt: "装備分布図は作成中です",
  RndUeh: "推定実行時間",
  RyXQqJ: "アップロード時間",
  S1QSWC: "サブストアにインポートする",
  S57QRB: "フィルター条件",
  SbZhau: "ブートタスクではブートデバイスを指定する必要があります",
  SkK50H: "スケジュールされたタスクを追加してください",
  SwMBFl: "スケジュールテンプレートを適用する",
  T3CtvK: "カテゴリ名を空にすることはできません",
  TDSTTj: "スケジュールテンプレートを選択してください",
  TDuPUp: "トリガーされた",
  TLZPhr: "月曜日",
  TYAJpp: "{num} 店舗が選択されました",
  UA7mv6: "オラの最終更新時間",
  UBbWUL: "テンプレートが選択されていません",
  UZ49sl: "担当者の電話番号",
  UtE0dS: "操作する",
  "Uu/nFu":
    "このデバイスに適用されているすべてのアラーム テンプレートを削除します",
  V0RiZp: "操作は成功しました",
  Vd3wZV: "全体",
  Ve9Ksw: "店舗移転",
  ViVQNi: "役割",
  VqEr9u: "申請店舗数",
  Vx4M25: "店舗コード",
  "W/wIZ8": "担当者",
  WYHxWn: "三つ",
  WYtW9Y: "バージョンを選択してください",
  WdyIyo: "稼働時間",
  WtPk7v: "SMSを同時に送信する",
  WxPZOH: "{num} 回実行します",
  WypzMq: "スケジュールされたタスク",
  Wzv7kF: "ストアを選択してください",
  X2PYza: "デバイスの詳細",
  "XKj/en": "BIOS のシリアル番号",
  "XLdI1+": "Wi-Fiの強さ",
  XMBOec: "タグを削除する",
  XPFi6q: "ストリップ",
  XmRKnc: "述べる",
  YYGRyG: "添付ファイルをアップロードしてください",
  YeF1dY: "タイムゾーン",
  YpXN8m: "最後のトリガー時間",
  YwEzx2: "表示する必要があるフィールドにチェックを入れます",
  ZGYHyC: "開始時間を空にすることはできません",
  ZQ91U9: "家",
  ZUPzqr: "オンにする",
  ZdO12B: "店舗に申し込む",
  "Zvt+2g": "倉庫保管",
  aBleoN: "アラームテンプレートの選択",
  aGxRt2: "コンテンツ",
  "aN+DgN": "起動時間",
  akvGrq: "ルールを構成する",
  askOz5: "住所検索",
  "b+Dz+s": "全店舗一覧",
  b5l2vN: "保存",
  bBz42a: "ステータスを更新する",
  "bE+h3K": "デバイスのステータス",
  bFBjSK: "五",
  bOKDVF: "ラジオを切り替えます",
  biXcnk: "担当者のメール",
  bqbDVw: "クエリ",
  bzfrYI: "アナウンス設定",
  cDZ00w: "チェック",
  "cZ9/ZC": "[{名前}]を削除しますか?",
  cawvIS: "最終更新日",
  cgIBtg: "上位レベルを選択",
  cr1ymH: "送信時間を選択してください",
  "d7i/AT": "上層",
  dEXfrL: "デバイスの健全性ステータスの間隔",
  dGBGbt: "全て",
  drCsUI: "会社",
  eAgY2G: "子会社の拡大",
  eCCa0L: "タスクの種類",
  "eP/37G": "登録時間",
  eeCxuz: "OSの種類",
  evJP5c: "命名規則",
  f7Dpbl:
    "テンプレートをダウンロードし、テンプレートのプロンプトに従ってコンテンツを改善します",
  "fc12+X": "金曜日",
  fz2pkM: "ノードが削除されました",
  gU4eZD: "アラーム管理",
  gmUXEi: "機器特性値",
  gnNjS5: "個人のデバイス名",
  gpg5DN: "お知らせを見る",
  gplM71: "毎日",
  "gyh+d1": "有線ネットワーク",
  "h/j3a5": "連絡先電話番号",
  h7w4pz: "まだデータがありません",
  "hD7/Lu": "見せる",
  "hDx3/S": "郵便",
  hEI4G8: "新しいお知らせ",
  hYN7oM: "隠れる",
  hkJXyi: "スケジュールされたタスクを構成する",
  i5MLJc: "最終更新日: {lastUpdate}",
  "i6kDf/":
    "選択したデバイスに {num} 個の Nubis Free バージョンが含まれている場合、デバイス コマンドは使用できません。",
  iKomBu: "まだ分​​類されていません",
  iN7Lps: "サイクルモード",
  ich0wH: "デバイスSN",
  ifGp4v: "2FA",
  "j/YGZ0": "地図",
  j3QWSE: "自然数増分の開始番号は正の整数のみです",
  j6m8Si: "連絡先メールアドレス",
  jAAXdQ: "装備品店",
  jT6zKT: "デバイスの数",
  "jhfb/7": "正常に保存されました",
  js3tZs: "スケジュールテンプレート名",
  k7dy8j: "関連する設定ファイル",
  k9dozc: "実行時間",
  kG2Etz: "オンライン",
  khyRcw: "Excelファイルを選択してください",
  "kr+7Iy": "店舗を探す",
  l36W55: "スクロールプレイ",
  lK6HPZ: "店舗のステータスを選択してください",
  lVgYx7: "一時停止中",
  lllhRf: "終了時刻を空にすることはできません",
  loTFGc: "無名",
  m1h20o:
    "後でスケジュール テンプレートの内容が更新された場合、適用されたデバイスにも同期されます。",
  mFIXSq: "デバイスのシリアル番号",
  mKKd1R: "受信者を選択してください",
  "mYa6W/": "カスタムテキスト",
  ma6S6y: "カスタムディスプレイ",
  mn0ceu: "重複した構成ルールがあります。調整してください。",
  "mpeFt+": "アラームルール",
  nGubXb: "スケジュールテンプレートの詳細",
  nUSeQB: "アカウントが選択されていません",
  nzsNwZ: "デバイスの健全性ステータス",
  "o+O5d1": "割り当てを選択してください",
  o5OLcm: "店舗略称",
  o8tJYm: "デバイスコマンド",
  o9lryN: "日曜日",
  "oFt+cN": "ネットワーク速度テスト",
  oW4Uka: "割り当てる",
  obfTaf: "ストア構成",
  ojz0Ke: "もっと見る >",
  oru5FY: "スケジュールテンプレートを編集する",
  "p/3Nn5": "モバイルネットワーク",
  pBPyFt: "ヌビスバージョン",
  pK94Zd: "ストアにインポートする",
  "pV2t/S": "基本情報",
  pXEyon: "デバイスの種類",
  peNVzr: "{num} 週間ごと",
  peUIwk: "お知らせの作成",
  pfGGi0:
    "現在デバイスに適用されているスケジュール テンプレートを削除し、実行しなくなります。",
  pielKO: "ブートデバイス",
  q6qKtH: "クエリ条件:",
  q9PHLT: "まだ発表はありません",
  q9YGIf: "仕事",
  qDba8m: "オフラインデバイスのステータス",
  qUKj7E: "コピー",
  qUiH5y: "構成ルールを空にすることはできません",
  "qqwM/t": "設定ファイル",
  qyh9hz: "営業時間",
  "r0/TUu": "もちろん",
  "r2dEd/": "リセット",
  rAKRwm: "デバイスのバージョンを選択してください",
  rDRAr0: "オペレーティング システムのバージョン",
  s1l1Jq: "ストアとアカウントの管理",
  s7NSze: "操作を確認する前に、アカウントのパスワードを入力してください。",
  s9U9qn: "アラームを設定する",
  sGYTej: "休む",
  sOIerB: "アクティブ化されていません",
  sVsXUO: "水曜日",
  sZSyGZ: "有効にする",
  srEpKw: "アップロード中",
  srpWCM:
    "表示する必要があるフィールドをチェックし、ドラッグして並べ替えます。",
  t5gffJ: "設備情報",
  tugHWJ: "お知らせ一覧に戻る",
  u3dVQz: "毎週",
  ubuOXs: "登録済み",
  ujBeLh: "保守体制公示",
  "uoZwj+": "クリエイター",
  uuRzdk: "店に所属している",
  v04auv: "終了時間",
  vD5wnY:
    "所属したい店舗にチェックを入れる（店舗の許可を得ていることを意味します）",
  vDCwZ9: "ファイルをアップロードする",
  vr5TVT: "入力してください",
  wOHHSJ: "上に移動",
  wQAiLI: "リマインダーをリセットする",
  wYygRu: "差出人",
  "wrU/Kc": "{num} 日ごと",
  x34QXR: "終了時刻を開始時刻より早くすることはできません",
  xI0mPJ: "すでにオンになっています",
  xISm1t: "アクティベーション",
  xUjLTE: "検索",
  xXdMar: "ユーザーの指定",
  xuf2rG: "全店舗",
  xx40g7: "お知らせタイトル",
  "y+WxsP": "編集上の通知",
  yKFvYY: "メールを同時に送信する",
  yOMNOj: "はい",
  yReEcE: "ラベルを選択",
  yb3AuG: "オフライン",
  ybGQQ3: "関連する結果はありません",
  yc6ZUL: "Ora の最終更新ステータス",
  ydktLD: "デリミタ",
  yeCGlM: "六",
  yfhtRM: "付録",
  ygAHaf: "送信時間",
  yy7EDI: "アップロード",
  zftpop: "ユーザーの選択",
  znuEgQ: "営業時間を追加",
  zok1hp: "Cスロット",
  zvaxmN: "スケジュール管理",
  zyMKgy: "ストアを選択",
  o5QBKU: "会社の更新に成功しました",
  "1yM7WW": "選択したデバイスを削除しますか?",
  DqB8kg: "デバイスを削除します",
  QH21BX: "機器の一括登録",
  TlDh4N: "デバイスを一括で削除します",
  UcumBq: "アラーム通知",
  X9zJwr: "デバイスをバッチで割り当てる",
  lkP6UV: "デバイスを更新",
  wLyMu9: "テンプレートのプロンプトに従ってコンテンツを改善します",
  FQM81K: "選択した店舗ステータスをに変更するかどうか",
  WqfGVu: "30語までに制限されています",
  hV5chR: "ウィンドウをポップアップするかどうかを選択してください",
  vD7UHb: "ポップアップウィンドウ",
  "0Drg5o": "上記の条件に同意します",
  "7pY6K/": "利用規約",
  CNkomH: "編集規約",
  CoaQps: "用語管理",
  "HHA/d7": "用語一覧",
  UH1kCc: "追加",
  "VzqtN+": "利用規約は必須です",
  hOtsIx: "新しい記事",
  ilUpPP: "用語のリストを返す",
  "j+y4w+": "用語タイトルは必須です",
  j4CmNU: "利用規約を表示",
  jJg298: "記事タイトル",
  t4lrWD: "記事のタイトルは30文字を超えてはなりません",
  z7A1Fc: "用語を作成",
  "OY+bYK": "確認します。今後は表示しないでください。",
  "+d1f6p": "Linuxデバイスのアップロード",
  UrM0bR: "認証情報",
  "+uAolt": "例: ユーザーがウェブサイトのタイトル、アイコン、テキストを簡単にカスタマイズして、パーソナライズされたウェブエクスペリエンスを実現できるようにします。",
  "0UAhKu": "例: https://nubiscloud.freshdesk.com/support/home",
  "0h3ZUE": "アカウントセンターへのアップロード",
  "0lEh3g": "Nubis Spaceへのアップロード",
  "0xMj0V": "例: 新しいバージョンを提供するか、デバイスイメージを更新する",
  "3DMdxJ": "DeviceCenterタブの編集",
  "4ImW13": "例: ストア管理",
  "52LsQF": "例: アカウントセンター",
  "5BTra1": "例: プラットフォーム",
  "61gplm": "テキストアップロード",
  "6sZvzw": "DeviceCenterキーワードの置き換え",
  "7bKyxU": "アップロードされた画像はNubis Driveファイルブラウザに保存されます。ファイルが破損または削除されると、画像の読み込みに失敗します",
  "7q8OJE": "プラットフォームの編集",
  "8TfVSD": "プラットフォームタブの編集",
  "8pToBN": "例: Cloud",
  "9/8z30": "ユーザーがウェブサイトのタイトル、アイコン、テキストを簡単にカスタマイズして、パーソナライズされたウェブ体験を提供",
  "9C+wuW": "例：デバイス管理",
  "D1cAYC": "例：デバイスセンター",
  "FKBH20": "例：Nubis Space",
  "G+eQYn": "例：ストアとアカウント管理",
  "G2LkOf": "お知らせ管理のアップロード",
  "I9uxGU": "例：グローバルサービス、想像力を創造し、インテリジェントな体験を提供",
  "K1Xqdl": "例：権限管理",
  "LTVlAP": "アップグレードセンターへのアップロード",
  "Q1/SUP": "例：メンテナンスシステムのお知らせ",
  "QAN35o": "例：デバイス管理、監視、リモートコントロールなど",
  "R8nCNR": "デバイス管理へのアップロード",
  "TVuUjT": "Ora",
  "U08bUN": "デバイスへのアップロードセンター",
  "Wu2nnZ": "プラットフォームの紹介",
  "ZP1/uy": "例：Nubisプラットフォームのロール権限の管理",
  "ayjmy+": "例：世界中のデバイスとグループの管理",
  "bhXvJB": "権限管理アップロード",
  "cAIDk5": "サポートセンター",
  "d3b8dv": "パーソナライズ管理アップロード",
  "dFHONh": "Nubis",
  "dWy8l5": "例：Ora",
  "fZJ9SZ": "例：パートナーとクライアントのアカウント管理",
  "jAmQmn": "例：開発センター",
  "kwx95y": "例：パーソナライズ管理",
  "ov96O9": "パーソナライズ管理",
  "rM4ciX": "例：アナウンス管理",
  "uDYj3x": "ウェブサイトセンター",
  "uRrPru": "ストア管理アップロード",
  "vdUVb9": "例: アップグレードセンター",
  "xrKftB": "アイコンのアップロード",
  "2IaM+V": "アップデートセンター",
  "EoXhnk": "デバイスセンター",
  "JeSd9K": "その他",
  "wzIKok": "上位会社の個人設定を継承します",
  "BQDKvZ": "例: エージェント",
  "EO9pTF": "例: クラウド",
  "/NrLZv": "ライセンス数",
  "1Dklb3": "自動有効日",
  "1dyq46": "CMS",
  "1t0NXU": "支払日",
  "2DbIoa": "注文詳細",
  "2hUF5M": "ライセンスを少なくとも1つ選択してください",
  "2qqw4C": "営業担当者",
  "3Y6eOz": "有効期限切れ",
  "5FboZ/": "種類",
  "6bBRd8": "お客様メールアドレス",
  "6jMfox": "注文記録受領",
  "D0cpCO": "ライセンス数",
  "EBMdAL": "作成完了",
  "FDRhoz": "送信済み",
  "G0UYbD": "ライセンスを選択",
  "GCrD1e": "残り日数",
  "JeSd9K": "その他", "JmnNA0": "任意項目",
  "LG70v2": "注文記録を送信",
  "NZQWZL": "正式",
  "PjtWQX": "選択したライセンス数 {num}",
  "Plhuph": "注文番号、ERP番号を検索",
  "Rrwy85": "作成者",
  "TX6jKq": "受取人",
  "U+pKlD": "注文番号 {name} を削除しますか？",
  "Xvn+2E": "顧客連絡先",
  "YII2+w": "有効期限",
  "YJbxtM": "受取会社",
  "ZIJmYm": "注文管理",
  "ZTs8/J": "ライセンスを作成",
  "a7AYs5": "有効期間（日数）",
  "eM8o1Y": "注文番号",
  "eUSpdN": "詳細を表示",
  "er7lkB": "金額", "fyjje7": "ライセンスキー",
  "gqvOsW": "顧客担当者", "iTiIWl": "一致するデータが見つかりません",
  "k1xuGk": "注文番号を検索",
  "kPb1Wj": "ERP番号",
  "lfUbAE": "有効",
  "mPsm6o": "テスト中",
  "ouraCD": "デバイス管理",
  "pUL1dA": "注文を削除",
  "pecEGk": "キャンセル",
  "sTreBL": "実際の有効日",
  "sbThvA": "送信元会社",
  "svGx//": "有効な番号を入力してください",
  "tMGiGt": "ライセンスの種類",
  "tsV2n0": "注文を作成",
  "twizE+": "営業担当者のメールアドレス",
  "u6rHwS": "注文生成日",
  "vePxOp": "正常", "wNYTXq": "未使用",
  "wawZXM": "ライセンスのステータス",
  "xVTk70": "読み込み中",
  "xxFsds": "必須項目",
  "0axARa": "有効期限",
"0tqhdw": "マネージャー以上の権限を持つユーザーは、[{x}] 社、合計 [{y}] 社からメールを受け取ります。",
"4DfIa5": "選択したライセンスの種類はベータ版ではありません。",
"4kc3eS": "毎月 1 日に、通知が必要なライセンスまたはデバイスのステータスに関するメールが送信されます。メールには以下の情報が含まれます。",
"7FTqlN": "一致するライセンスがありません。",
"AfMAI0": "ライセンスを保有するデバイスは、現在のライセンスの有効期限が切れると、自動的に新しいライセンスを受け取ります。",
"FQjcoc": "ライセンス自動化ルール",
"GDWKlf": "ペアリングされたデバイスのシリアル番号",
"Iqlkbs": "選択したライセンスのステータスは未使用である必要があります。",
"K5iYC8": "今後 100 日以内に自動アクティベーション日を迎える未使用のライセンスです。",
"NBz0wZ": "現在有効ですが、どのデバイスにも割り当てられていないライセンスです。",
"URkpah": "期限切れのライセンスです。", 
"UjxKxu": "終了しました。",
"VaAWfW": "自動有効期限が近いライセンスが優先されます。",
"Wp2PXY": "通知設定",
"X2YceA": "未使用のライセンスです。",
"ZLqStU": "事前インポートされたデバイスは、登録時に自動的にライセンスを受け取ります。",
"daUauj": "ライセンスキー、注文番号、ペアリングされたデバイスのシリアル番号",
"eFFkgE": "ライセンスインベントリの概要",
"eHMGvf": "ライセンスを選択してください。",
"eR85km": "デバイスに付与された認証済みライセンスの有効期限が100日以内に切れます。ライセンスの有効期限が切れ、代替ライセンスが提供されない場合、デバイスは予約済み状態になります。",
"fTfy0b": "システムはライセンス自動化ルールに従ってライセンスを自動的に適用します",
"ftSBnR": "ペアリングされたライセンス",
"lLC16+": "ライセンス管理",
"lQGDqR": "デバイスは既に予約済みまたは一時停止状態です。",
"lTtEaU": "予約済み", "t0EXqz": "有効なライセンス",
"vPHZLC": "子会社を含む",
"xy6tQS": "ORコードまたはAPI経由で登録されたデバイスには自動的にライセンスが適用されます",
"zE041n": "有効期限",
"FQQECq": "必須",
"ekxzlF": "名前"
};
